import React from "react";

export const LostObjectsHistoryTab = () => {
	return <div>LostObjectsHistoryTab</div>;
};
